// import React from "react";
// import Button from "@mui/material/Button";
// import { toJpeg } from "html-to-image";

// const DownloadJpegButton = ({ targetRef }) => {
//   const handleDownload = () => {
//     if (!targetRef?.current) return;

//     toJpeg(targetRef.current, { quality: 0.95 })
//       .then((dataUrl) => {
//         const link = document.createElement("a");
//         link.download = "chart.jpeg";
//         link.href = dataUrl;
//         link.click();
//       })
//       .catch((err) => {
//         console.error("Failed to download image", err);
//       });
//   };

//   return (
//     <Button
//     variant="contained"
//     color="primary"
//     size="small"
//     sx={{
//       padding: "3px 12px",
//       fontSize: "0.75rem",
//       fontWeight: "600",
//       textTransform: "none",  // prevent uppercase default
//       borderRadius: "8px",
//       boxShadow: "0 3px 5px 2px rgba(100, 149, 237, .3)",  // subtle shadow
//       "&:hover": {
//         backgroundColor: "#3f51b5",  // slightly darker on hover
//         boxShadow: "0 6px 10px 4px rgba(100, 149, 237, .35)",
//       },
//     }}
//     onClick={handleDownload}
//   >
//     Download
//   </Button>
  
//   );
// };

// export default DownloadJpegButton;


import React from "react";
import Button from "@mui/material/Button";
import { toJpeg } from "html-to-image";

const DownloadJpegButton = ({ targetRef, fileName = "chart.jpeg" }) => { // fileName prop with default
  const handleDownload = () => {
    if (!targetRef?.current) return;

    toJpeg(targetRef.current, { quality: 0.95 })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = fileName;  // Use dynamic file name on download
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.error("Failed to download image", err);
      });
  };

  return (
    <Button
      variant="contained"
      color="primary"
      size="small"
      sx={{
        padding: "2px 10px",
        fontSize: "0.75rem",
        fontWeight: "600",
        textTransform: "none",
        borderRadius: "10px",
        boxShadow: "0 3px 5px 2px rgba(100, 149, 237, .3)",
        "&:hover": {
          backgroundColor: "#3f51b5",
          boxShadow: "0 6px 10px 4px rgba(100, 149, 237, .35)",
        },
      }}
      onClick={handleDownload}
    >
      Download
    </Button>
  );
};

export default DownloadJpegButton;

